import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "src/components/ui/Card";
import { Button } from "src/components/ui/Button";
import { Pencil, Trophy } from "lucide-react";
import { Modal } from "src/components/ui/Modal";
import { StudentExtendedProfileData } from "src/pages/student/Profile";
import { ChipInput } from "src/components/ui/ChipInput";

interface AchievementsSectionProps {
  profileData: StudentExtendedProfileData;
  editData: Partial<StudentExtendedProfileData>;
  activeSectionEdit: string | null;
  setActiveSectionEdit: (section: string | null) => void;
  updateEditData: (field: string, value: any) => void;
  updateProfile: (data: Partial<StudentExtendedProfileData>) => Promise<void>;
}

const AchievementsSection: React.FC<AchievementsSectionProps> = ({
  profileData,
  editData,
  activeSectionEdit,
  setActiveSectionEdit,
  updateEditData,
  updateProfile
}) => {

  return (
    <>
      {/* Achievements Section */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>Achievements</CardTitle>
          <button
            onClick={() => setActiveSectionEdit('achievements')}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Edit Achievements"
          >
            <Pencil className="h-4 w-4 text-gray-500" />
          </button>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {profileData.academicHistory?.achievements?.length > 0 ? (
              <ul className="space-y-2 pl-0">
                {profileData.academicHistory.achievements.map((achievement, index) => (
                  <li key={index} className="flex items-center text-md">
                    <span className="text-green-600 mr-2 text-lg font-bold">✓</span>
                    <span>{achievement}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500">No academic achievements specified</p>
            )}
          </div>
        </CardContent>
      </Card>

      {/* Achievements Edit Modal */}
      {activeSectionEdit === 'achievements' && (
        <Modal
          isOpen={activeSectionEdit === 'achievements'}
          onClose={() => setActiveSectionEdit(null)}
          title="Edit Achievements"
        >
          <div className="space-y-5">
            <ChipInput
              label="Achievements"
              value={editData.academicHistory?.achievements || []}
              onChange={(chips) => {
                const values = Array.isArray(chips)
                  ? chips.map((chip) => typeof chip === 'string' ? chip : chip.value)
                  : [];
                updateEditData("academicHistory", {
                  ...editData.academicHistory,
                  achievements: values
                });
              }}
              options={[]}
              allowCustom={true}
              multi={true}
              placeholder="Press Enter to add Achievements"
              showDropdown={false}
              required={false}
            />
          </div>
          <div className="flex flex-row w-full gap-2 mt-6 justify-between">
            <Button variant="outline" onClick={() => setActiveSectionEdit(null)} className="w-32">
              Cancel
            </Button>
            <Button onClick={() => {
              updateProfile(editData);
              setActiveSectionEdit(null);
            }} className="w-32">
              OK
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AchievementsSection;
